import { useCallback, useEffect, useState } from "react";

const useLocalStorage = function <T>(key: string, defaultValue: T): [T, (value: T) => void] {
  // Always start with defaultValue so SSR and client first-render agree (no hydration mismatch).
  // The stored value is read after mount in useEffect.
  const [value, setValue] = useState<T>(defaultValue);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(key);
      if (stored !== null) {
        setValue(JSON.parse(stored) as T);
      }
    } catch {
      // keep defaultValue
    }
  }, [key]);

  const setValueAndStore = useCallback(
    (newValue: T) => {
      setValue(newValue);
      try {
        localStorage.setItem(key, JSON.stringify(newValue));
      } catch {
        localStorage.removeItem(key);
      }
    },
    [key],
  );

  return [value, setValueAndStore];
};

export default useLocalStorage;
